export var RPCMethod;
(function (RPCMethod) {
    // MethodSubmitTx submits a new transaction to the Darknode for acceptance
    // into the transaction pool.
    RPCMethod["MethodSubmitTx"] = "ren_submitTx";
    // MethodQueryTx returns the latest information about a transaction
    // identified by a transaction hash.
    RPCMethod["MethodQueryTx"] = "ren_queryTx";
    // MethodQueryTxs returns pages of transactions with optional filtering by
    // status and tags.
    RPCMethod["MethodQueryTxs"] = "ren_queryTxs";
    // MethodQueryBlock returns a block identified by the block height.
    RPCMethod["MethodQueryBlock"] = "ren_queryBlock";
    // MethodQueryBlocks returns recently committed blocks.
    RPCMethod["MethodQueryBlocks"] = "ren_queryBlocks";
    // MethodQueryNumPeers returns the number of known peers.
    RPCMethod["MethodQueryNumPeers"] = "ren_queryNumPeers";
    // MethodQueryPeers returns a random subset of known peers.
    RPCMethod["MethodQueryPeers"] = "ren_queryPeers";
    // MethodQueryShards returns information about the currently online/offline
    // Shards.
    RPCMethod["MethodQueryShards"] = "ren_queryShards";
    // MethodQueryStat returns status information about the Darknode. This
    // information cannot be verified.
    RPCMethod["MethodQueryStat"] = "ren_queryStat";
    // MethodQueryFees returns information about the current RenVM fees and
    // underlying blockchain fees. This information cannot be verified.
    RPCMethod["MethodQueryFees"] = "ren_queryFees";
})(RPCMethod || (RPCMethod = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVuVk1UeXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZW5WTVR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFBLE1BQU0sQ0FBTixJQUFZLFNBZ0NYO0FBaENELFdBQVksU0FBUztJQUNqQiwwRUFBMEU7SUFDMUUsNkJBQTZCO0lBQzdCLDRDQUErQixDQUFBO0lBQy9CLG1FQUFtRTtJQUNuRSxvQ0FBb0M7SUFDcEMsMENBQTZCLENBQUE7SUFDN0IsMEVBQTBFO0lBQzFFLG1CQUFtQjtJQUNuQiw0Q0FBK0IsQ0FBQTtJQUUvQixtRUFBbUU7SUFDbkUsZ0RBQW1DLENBQUE7SUFDbkMsdURBQXVEO0lBQ3ZELGtEQUFxQyxDQUFBO0lBRXJDLHlEQUF5RDtJQUN6RCxzREFBeUMsQ0FBQTtJQUN6QywyREFBMkQ7SUFDM0QsZ0RBQW1DLENBQUE7SUFFbkMsMkVBQTJFO0lBQzNFLFVBQVU7SUFDVixrREFBcUMsQ0FBQTtJQUVyQyxzRUFBc0U7SUFDdEUsa0NBQWtDO0lBQ2xDLDhDQUFpQyxDQUFBO0lBRWpDLHVFQUF1RTtJQUN2RSxtRUFBbUU7SUFDbkUsOENBQWlDLENBQUE7QUFDckMsQ0FBQyxFQWhDVyxTQUFTLEtBQVQsU0FBUyxRQWdDcEIifQ==